import React from 'react'
import './index.css'

function ForsageTitleLg() {
    return (
        <div className='forsage-title-lg'>
            <div>
                <span id='forsage-title-lg-tleuno'>Forsage x3</span>
            </div>
            <div>
                <span id='forsage-title-lg-tledos'>0 BUSD</span>
            </div>
        </div>
    )
}

export default ForsageTitleLg